import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const testSlice = createSlice({
  name: "testSlice",
  initialState: {
    test: [],
    eligibility: {},
    studentList: [],
    gradeGroup: [],
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },
  reducers: {
    setTestData: (state, action) => {
      state.test = action.payload;
    },
    setEligibilityData: (state, action) => {
      state.eligibility = action.payload;
    },
    setStudentList: (state, action) => {
      state.studentList = action.payload;
    },
    setGradeGroup: (state, action) => {
      state.gradeGroup = action.payload;
    },
    setRemoveGradeGroup: (state, action) => {
      state.gradeGroup = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
  },
});

const {
  setTestData,
  setEligibilityData,
  setStudentList,
  setErrorMessage,
  setDataFetchingStatus,
  setGradeGroup,
  setRemoveGradeGroup,
  setErrorStatusCode,
} = testSlice.actions;

export const getTest = (classId) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .get(`faculty/testsandscores/${classId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setTestData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const deleteTest = (testId) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .delete(`faculty/testsandscores/${testId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getTestEditEligibility = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .get(
      `faculty/testediteligibility?classId=${data.classId}&contactId=${data.contactId}`,
    )
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setEligibilityData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getTeststudentList = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .get(`faculty/test/students/${data.testId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setStudentList(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const patchTeststudentList = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .patch(`faculty/test/students/${data.testId}`, {
      classId: data.classId,
      data: data.data,
    })
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const patchTestDetails = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .patch(`faculty/testsandscores/${data.testId}`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getGradeGroup = () => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .get("faculty/test/gradegroup")
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setGradeGroup(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const createTest = (data) => (dispatch) => {
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  dispatch(setDataFetchingStatus(true));
  axios
    .post("faculty/test", data)
    .then((response) => {
      dispatch(setErrorMessage(response.data.message));
      dispatch(setDataFetchingStatus(false));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const removeGradeGroup = () => (dispatch) => {
  dispatch(setGradeGroup([]));
};

export const removeStudentList = () => (dispatch) => {
  dispatch(setStudentList([]));
};
export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};
export default testSlice.reducer;
